var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-banner"},[_c('div',{staticClass:"banner_info"},[_c('h3',[_vm._v("广为科技")]),_c('p',[_vm._v("追溯数字化解决方案提供商")])])])}]

export { render, staticRenderFns }